
<template>
  <div class="vip_box">
    <img src="../../assets/img/vip/success.png"
         alt=""
         class="icon_succ">
    <p class="pay_succ">还款申请成功</p>
  </div>
</template>

<script>

export default {
  components: {
    // Head,
  },
  data () {
    return {
      timer: null,
      showIdx: 0,
      page: ''
    }
  },
  mounted () {
    this.page = this.$route.query.page;
    this.util.title('还款结果');
    let _this = this;
    this.timer = setInterval(() => {
      this.showIdx++
      console.log(this.showIdx)
      if (this.showIdx == 3) {
        this.goHome();//回到首页
      }
    }, 1000);
  },
  methods: {
    //跳转客户端
    goHome () {
      let json = {
      }
      try {
        window.webkit.messageHandlers.goHome.postMessage(json);//ios
      } catch (err) {
        window.AppJs.goHome();//android
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timer);
    this.timer = null;
  },

}
</script>
<style scoped>
.vip_box {
  text-align: center;
  padding-top: 0.68rem;
  /* box-shadow: 0px 1px 0px 0px rgba(255, 0, 0, 1); */
}
.icon_succ {
  width: 1rem;
  height: 1rem;
  margin: 0 auto;
}
.pay_succ {
  color: #333333;
  font-size: 0.2rem;
}
</style>
